
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentDbApi } from '../../../apis/patent-db-api';
import type { IDbConfigResponse, PatentDbService } from '../patent-db-service';

@injectable()
export class PatentDbServiceImpl implements PatentDbService {
    constructor(
        @inject(PatentDbApi)
        private readonly _patentDbApi: PatentDbApi
    ) {}

    getDbConfig(): Promise<IDbConfigResponse> {
        return this._patentDbApi.getDbConfig();
    }
}
